import React from 'react';
import { ManuallyPairedDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { IconButton } from '@mui/material';
import { IconAdd } from '../../../../../../assets/icons/icon-add';
import { DeviceIcon } from '../../../../components/device/icon';
import { useManuallyPaired } from '../../hooks/use-manually-paired';
import './index.scss';

type ManuallyDeviceProps = {
  device: ManuallyPairedDevice;
};

const ManuallyDevice: React.FC<ManuallyDeviceProps> = ({ device }) => {
  const { addManuallyDevice } = useManuallyPaired();

  const registerManually = () => addManuallyDevice(device);

  return (
    <div className="found-driver m-b-24 ">
      <DeviceIcon iconType={device.IconType} />
      <h4 className="found-driver--header">
        <div className="found-driver--header-title">
          <div className="found-driver--header-title-name text-ellipsis">{device.Model || ''}</div>
        </div>
      </h4>
      <IconButton className="register-btn" onClick={registerManually}>
        <IconAdd />
      </IconButton>
    </div>
  );
};

export default ManuallyDevice;
